import React from 'react';
import { Link } from 'react-router';
import { HStack } from 'components/layouts/primitives/Stack/Stack';
import { PButtonIcon } from 'components/prime/PButton/PButtonIcon';
import { Text } from 'components/Text/Text';
import { useIsReactPage } from 'hooks/useIsReactPage';

export const LayoutDashboardLeftMenuSettingsHeader: React.FC = () => {
  const isReactPage = useIsReactPage();
  const button = <PButtonIcon icon="arrowLeftLine" size="sm" className="left-menu-back-button" />;
  return (
    <HStack stretch gap="gap2" align="center" justify="flex-start">
      {isReactPage ? <Link to="/">{button}</Link> : <a href="/">{button}</a>}
      <Text color="neutral600" size="fontSizeSM" lineHeight="lineHeightMD" weight="medium">
        Back to Yabble
      </Text>
    </HStack>
  );
};
